module.exports = __webpack_public_path__ + "img/blue.c0433239.svg";